import React from "react";
import { Spinner } from "react-bootstrap";

/**
 * Small presentational helpers shared by the My Learning tab panels
 * (Materials / Assignments / Coding Challenges). Kept tiny and dependency-free
 * so each panel stays self-contained.
 */

export const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "Asia/Kolkata",
      })
    : "";

export const PanelLoading = () => (
  <div className="ml-loading">
    <Spinner animation="border" />
  </div>
);

export const PanelEmpty = ({ icon: Icon, children }) => (
  <div className="ml-empty">
    {Icon && <Icon size={32} />}
    <p>{children}</p>
  </div>
);
